import { Rule } from './rule';

export class BlackjackCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.blackjack.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.blackjack.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.blackjack.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-2b' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-2c' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-2d' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-2e' },
      ],
    },
    {
      title: 'components.cheat-sheet.blackjack.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-3b' },
      ],
    },
    {
      title: 'components.cheat-sheet.blackjack.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-4b' },
      ],
    },
    {
      title: 'components.cheat-sheet.blackjack.header-5',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-5a' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-5b' },
        { type: 'text', content: 'components.cheat-sheet.blackjack.body-5c' },
      ],
    },
  ];
}
